class Search {
  constructor() {
    this.document = document;
    this.body = document.body;
    this.searchInput = document.querySelector(
      "form.search-form .form-control:first-child",
    );
    this.openSearchButton = document.querySelector("#btn-search");
    this.closeSearchButton = document.querySelector("#btn-search-close");
  }

  init() {
    this.openSearchButton.addEventListener("click", this.open.bind(this));
    this.closeSearchButton.addEventListener("click", this.close.bind(this));
    this.document.addEventListener("keydown", function (e) {
      if (e.key == "Escape") {
        this.body.classList.remove("search-open");
      }
    });
  }

  open() {
    this.body.classList.add("search-open");
    this.searchInput.focus();
  }

  close() {
    this.body.classList.remove("search-open");
    this.searchInput.value = null;
  }
}

export default Search;
